import request from '@/utils/request';

const requestInstance = request();

/**
 * 获取所有AppId
 * @returns {*}
 */
export function getAllAppId() {
  return requestInstance.post('/api/appInfo/getAllAppId');
}

/**
 * 获取所有App
 * @returns {*}
 */
export function getAllApp() {
  return requestInstance.post('/api/appInfo/getAllApp');
}

/**
 * 分页获取绑定统计
 * @returns {*}
 */
export function listUserBindDailyStatisticsByPage(parameter) {
  return requestInstance.post('/api/statistics/listUserBindDailyStatisticsByPage', parameter);
}

/**
 * 获取绑定统计
 * @returns {*}
 */
export function listUserBindDailyStatistics(parameter) {
  return requestInstance.post('/api/statistics/listUserBindDailyStatistics', parameter);
}

/**
 * 分页获取接口调量
 * @returns {*}
 */
export function listApiRequestDailyStatisticsByPage(parameter) {
  return requestInstance.post('/api/statistics/listApiRequestDailyStatisticsByPage', parameter);
}

/**
 * 获取昨日接口调量
 * @returns {*}
 */
export function getYesterdayApiRequestStatistics(parameter) {
  return requestInstance.post('/api/statistics/getYesterdayApiRequestStatistics', parameter);
}

/**
 * 获取昨日接口调量
 * @returns {*}
 */
export function getApiCascader() {
  return requestInstance.post('/api/apiInfo/getApiCascader');
}
